import React, {useEffect, useState} from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {cancelTimeZoneSetting, changeArea, initTimeZoneArea, saveTimeZoneSetting} from '@/businesses/timeZoneBusiness';
import TimezoneSelection from '@/components/selectField/TimezoneSelection';
import {RESET, SAVE} from '@/constants/pcConstAppData';
import useIntlFormat from '@/hooks/useIntlFormat';
import {disabledSaveTimezoneSetting} from '@/selectors/timeZoneSelector';

import './TimezoneSetting.less';

function TimezoneSetting() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntlFormat();

  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);

  const disabledSaveBtn = useSelector((state) => disabledSaveTimezoneSetting(state, {selectedArea, selectedRegion}));

  useEffect(() => {
    const init = async () => {
      const {areas, selectedArea, regions, selectedRegion} = await dispatch(initTimeZoneArea());

      setAreas(areas);
      setSelectedArea(selectedArea);
      setRegions(regions);
      setSelectedRegion(selectedRegion);
    };

    init();
  }, [dispatch]);

  const handleAreaChange = async (e) => {
    const {value} = e;

    const {regions, selectedRegion} = await dispatch(changeArea(value));

    setSelectedArea(value);
    setRegions(regions);
    setSelectedRegion(selectedRegion);
  };

  const handleRegionChange = (e) => {
    const {value} = e;
    setSelectedRegion(value);
  };

  function handleSaveClick() {
    dispatch(saveTimeZoneSetting(selectedArea, selectedRegion));
  }

  function handleCancelClick() {
    dispatch(cancelTimeZoneSetting());
  }

  return (
    <div className="timezoneContainer">
      <div className="timezoneArea">
        <TimezoneSelection
          label={formatMessage({id: 'timezoneSetting.label.area'})}
          value={selectedArea}
          options={areas}
          onChange={handleAreaChange}
        />
        <br />
      </div>

      <div className="timezoneRegion">
        <TimezoneSelection
          label={formatMessage({id: 'timezoneSetting.label.region'})}
          value={selectedRegion}
          options={regions}
          onChange={handleRegionChange}
        />
        <br />
      </div>

      <div className="row center timezoneBtnContainer">
        <div className="col-md-3 center btnContainer">
          <button
            type="button"
            id={RESET}
            className="cancelButton "
            onClick={handleCancelClick}
          >
            {formatMessage({id: 'general.label.cancel'})}
          </button>
        </div>
        <div className="col-md-3 center btnContainer">
          <button
            type="button"
            id={SAVE}
            className="saveButton "
            onClick={handleSaveClick}
            disabled={disabledSaveBtn}
          >
            {formatMessage({id: 'general.label.apply'})}
          </button>
        </div>
      </div>
    </div>
  );
}

export default TimezoneSetting;
